import React from "react";
import Caution from "./svg/Caution";

const ProfileNotification : React.FC<any> = ({text}) => {
  return (
    <div className="profile-notification">
      <div className="profile-notification--icon">
        <Caution />
      </div>
      <p>{text}</p>

    </div>
  );
}

export default ProfileNotification;